/* Haircare PDP - add-to-cart for the ritual rail and band.
   Self-contained: posts to /cart/add.js, then updates the header cart
   bubble in place. Deliberately does not couple to the theme's cart
   drawer internals, so a Dawn upgrade cannot silently break it. */
(function () {
  'use strict';

  function refreshCartCount() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var bubbles = document.querySelectorAll(
          '.cart-count-bubble span[aria-hidden="true"]'
        );
        bubbles.forEach(function (el) {
          el.textContent = cart.item_count;
        });
        var icons = document.querySelectorAll('#cart-icon-bubble');
        icons.forEach(function (icon) {
          if (cart.item_count > 0 && !icon.querySelector('.cart-count-bubble')) {
            var bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubble.innerHTML =
              '<span aria-hidden="true">' + cart.item_count + '</span>';
            icon.appendChild(bubble);
          }
        });
      })
      .catch(function () {
        /* count refresh is cosmetic - the item is already in the cart */
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.hc-add');
    if (!button || button.disabled) return;

    var variantId = button.dataset.variantId;
    if (!variantId) return;

    event.preventDefault();

    var originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        button.textContent = button.dataset.addedLabel || 'Added';
        return refreshCartCount();
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = originalLabel;
        /* Fall back to the standard cart page so the shopper is never
           left with a button that silently did nothing. */
        window.location.href =
          window.Shopify.routes.root + 'cart/add?id=' + variantId;
      });
  });
})();
